import React, { useEffect, useRef, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CreateVRF from "./createVisaRequestForm";
import { axios } from "../../../../Global";
import CommonreturnPopUp from "../../../../ReusableComponents/VRFRequestPopUp";
import { setAppError } from "../../../../store/userSlice";
import { getVisaRequestData } from "../../../../store/Api";
import { useDispatch } from "react-redux";
import { sortByName } from "../../../../utils/sortByName";

export default function Grdeskpopup({
  showPromptElement,
  popupData,
  setShowPromptElement,
  status,
}) {
  const validationSchema = Yup.object().shape({
    visaProvider: Yup.string(),
    total_visa: Yup.number().required().min(1),
  });
  const dispatch = useDispatch();

  console.log("popupData....popupData", popupData);
  const {
    register,
    control,
    watch,
    handleSubmit,
    getValues,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const formRef = useRef(null);

  const formChange = (event) => {
    let formDetails = getValues();
  };
  const [data, setData] = useState(popupData);
  const token = localStorage.getItem("nodeToken");
  const [loading, setLoading] = useState(false);
  const [fieldDropdownData, setFieldDropdowndata] = useState();
  const laravelToken = localStorage.getItem("token");
  const [visaProvider, setVisaProvider] = useState();
  const visa_provider = async () => {
    const response = await axios.get("dashboard/company", {
      headers: {
        Authorization: `Bearer ${laravelToken}`,
      },
    });
    if (response.status === 200) {
      console.log(
        "res?.data?.data?.visaProvider",
        response?.data?.data?.company
      );
      setVisaProvider(sortByName(response?.data?.data?.company));
    }
  };

  useEffect(() => {
    setValue("total_visa", popupData.listData.total_visa);
    visa_provider();
  }, []);

  const handleVisaChange = async (event) => {
    console.log("event", event.target.value);
    let reqObject = {
      company_id: event.target.value,
    };
    const response = await nodeinstance.post(
      `/dashboard/vrf-visa/getvisaproviderbyId`,
      reqObject,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.status === 200) {
      console.log("data to be printed here.........", response);
      setData(response.data.data);
    }
    console.log("evet to be triggred......", event.target.value);
  };
  console.log("event visa", popupData);

  const onSubmit = async (registerData) => {
    console.log(
      "Api call need to be done here.....",
      registerData,
      data,
      popupData?.id
    );
    const reqObject = {
      company_id: data.company_id,
      sponsor_id: data.sponsor_id,
      total_visa: registerData.total_visa,
    };
    if ((registerData.total_visa = 0)) {
      alert("error");
    }
    const response = await nodeinstance.put(
      `/dashboard/vrf-visa/editVRFByGrDesk/${popupData?.id}`,
      reqObject,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.status === 200) {
      setShowPromptElement(false);
    }
    console.log("response", response);
  };
  const [DeletepopUp, setDeletePopUp] = useState(false);

  const handleRejectClick = () => {
    setDeletePopUp(true);
  };

  // const [action,setAction]
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
    routeName: "",
  });
  const handleReject = (type) => {
    setAddOrEdit((p) => ({
      ...p,
      open: true,
      method: "add",
      routeName: type,
    }));
  };

  const onRejectSubmit = async () => {
    const reqObject = {
      status: "REFUND INITIATED",
    };
    try {
      const response = await nodeinstance.put(
        `/dashboard/vrf-visa/updateStatus/${popupData?.id}`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Updates Successfully...",
            color: "success",
          })
        );
        setShowPromptElement(false);
        dispatch(getVisaRequestData(token));
      }
    } catch (error) {
      console.log("error to be seen here....", error);
      dispatch(
        setAppError({
          msg: error.message,
          // color : "success"
        })
      );
    }
  };
  return (
    <>
      {status === "PAYMENT DONE" ? (
        <>
          <div
            className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
              showPromptElement ? "flex" : "hidden"
            }`}
          >
            {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
            <div
              className={`max-w-lg w-full ${addOrEdit.open === false || addOrEdit.routeName === "rejection" ? "h-[200px]" : "h-[700px]"} overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative`}
            >
              <div className="flex justify-between items-center w-full">
                <h1
                  className="text-md font-semibold cursor-pointer"
                  onClick={() => {
                    setShowPromptElement(false);
                  }}
                >
                  <IoMdClose />
                </h1>
              </div>
              {addOrEdit.open === true ? (
                ""
              ) : (
                <>
                  <div className="flex gap-3 w-full justify-center mt-8">
                    <button
                      className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-blue text-white bg-blue"
                      // type="submit
                      onClick={() => {
                        handleReject("rejection");
                      }}
                    >
                      INTIATE REFUND
                    </button>
                    <button
                      className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
                      onClick={() => {
                        handleReject("Proceed");
                      }}
                    >
                      CONFIRM & PROCEED
                    </button>
                  </div>
                </>
              )}
              {addOrEdit.routeName === "rejection" ? (
                // <h2>gcdyygyfyugdfuyvgyugfuy</h2>4
                <>
                  <h2 className="mt-5 ml-10">
                    ARE YOU SURE TO DELETE THIS VISA REQUEST?
                  </h2>
                  <div className="flex gap-3 w-full justify-center mt-5">
                    <button
                      className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
                      onClick={() => {
                        onRejectSubmit();
                      }}
                    >
                      {"REJECT"}
                    </button>
                  </div>
                </>
              ) : addOrEdit.routeName === "Proceed" ? (
                <CreateVRF
                  grdesk={true}
                  vrfdata={popupData}
                  setShowPromptElement={setShowPromptElement}
                  setDeletePopUp={setDeletePopUp}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      ) : DeletepopUp === true ? (
        <CommonreturnPopUp
          DeletepopUp={DeletepopUp}
          setDeletePopUp={setDeletePopUp}
          status={
            status === "PAYMENT DONE" ? "REFUND INITIATED" : "GR REJECTED"
          }
          propId={popupData?.id}
          isOpsDelete={false}
          setShowPromptElement={setShowPromptElement}
        />
      ) : (
        <div
          className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
            showPromptElement ? "flex" : "hidden"
          }`}
        >
          <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
            <div className="flex justify-between items-center w-full">
              <h1
                className="text-md font-semibold cursor-pointer"
                onClick={() => {
                  setShowPromptElement(false);
                }}
              >
                <IoMdClose />
              </h1>
            </div>
            <form
              onChange={formChange}
              ref={formRef}
              onSubmit={handleSubmit(onSubmit)}
              autoComplete="off"
            >
              <div className="w-full flex flex-col gap-3 my-3 p-5">
                <div className="flex flex-col w-full gap-1">
                  <label htmlFor="" className="px-1">
                    VISA PROVIDER
                  </label>
                  <select
                    //   {...register("visaprovider")}
                    className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                    onChange={handleVisaChange}
                    value={data.company_id ? data.company_id : ""}
                  >
                    <option value="">{"SELECT VALUE"}</option>
                    {visaProvider?.map((data, index) => (
                      <React.Fragment key={index}>
                        <option value={data.company_id}>{data.name}</option>
                      </React.Fragment>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col p-2 gap-1 w-full max-w-md border-3 border-green-500 dark:bg-green">
                  <label htmlFor={`addOrEdit-name`} className="text-xs ">
                    SPONSOR ID
                  </label>
                  <input
                    type="text"
                    className="border border-red-500 dark:border-dark rounded-md p-1 py-2 text-green-300"
                    value={data.sponsor_id ? data.sponsor_id : ""}
                    disabled
                  />
                </div>
                <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                  <label htmlFor={`addOrEdit-name`} className="text-xs ">
                    TOTAL VISAS
                  </label>
                  <input
                    type="number"
                    className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                    {...register("total_visa")}
                  />
                </div>
              </div>
              <div className="flex gap-3 w-full justify-center">
                <button
                  className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-blue text-white bg-blue"
                  // type="submit"
                  disabled={status === "GR REJECTED"}
                  onClick={() => {
                    handleRejectClick();
                  }}
                >
                  REJECT
                </button>
                <button
                  className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
                  type="submit"
                  disabled={status === "GR REJECTED"}
                >
                  {loading ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
